'use client'

import { ArrowLeft } from 'lucide-react'
import Link from 'next/link'

import { Button } from '@/components/ui/button'

import { CodeStep } from './components/CodeStep'
import { EmailStep } from './components/EmailStep'
import { PasswordResetAlerts } from './components/PasswordResetAlerts'
import { SuccessStep } from './components/SuccessStep'
import { usePasswordResetFlow } from './hooks/usePasswordResetFlow'

export default function PasswordResetForm() {
  const {
    form,
    currentStep,
    isLoading,
    isInitializing,
    email,
    successMessage,
    errorMessage,
    handleSendCode,
    handleVerifyCode,
    handleResendCode,
    resetToEmailStep,
    stepMetadata
  } = usePasswordResetFlow()

  const showBackButton = currentStep === 'code'

  return (
    <div className="light space-y-6" style={{ colorScheme: 'light' }}>
      <div className="mb-6 text-center">
        <h1 className="mb-2 text-3xl text-gray-900">{stepMetadata.title}</h1>
        {stepMetadata.description && <p className="text-gray-600">{stepMetadata.description}</p>}
      </div>

      <div className="space-y-6">
        {showBackButton && (
          <Button
            variant="ghost"
            size="sm"
            onClick={resetToEmailStep}
            className="-ml-2 w-fit text-gray-600 hover:bg-gray-100 hover:text-gray-900"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        )}

        <PasswordResetAlerts
          successMessage={successMessage}
          errorMessage={errorMessage}
          isInitializing={isInitializing}
        />

        {currentStep === 'email' && (
          <EmailStep form={form} onSubmit={handleSendCode} isLoading={isLoading} isInitializing={isInitializing} />
        )}

        {currentStep === 'code' && (
          <CodeStep form={form} onSubmit={handleVerifyCode} onResend={handleResendCode} isLoading={isLoading} email={email} />
        )}

        {currentStep === 'success' && <SuccessStep />}
      </div>

      {currentStep === 'email' && (
        <div className="flex flex-col items-center gap-2">
          <Link href="/login" className="text-sm text-blue-600 hover:text-blue-700">
            Remember your password? Log in
          </Link>
        </div>
      )}
    </div>
  )
}
